import { IInstitutionInformationBean, IInstitutionBean, IInstitutionTableBean, IInstitutionRowBean, IInstitutionHeaderBean } from "./beans";
import { InstitutionInformation } from "../../..//domain/institution";
import { LightTable, Header, LightRow } from "../../../domain/system/table";

export class InstitutionInformationTranslator {
  public toInformation(bean: IInstitutionInformationBean): InstitutionInformation {
    if (!bean) { return null; }
    const info = new InstitutionInformation();
    const masterTable = this.toTable(bean.allInstitutionTable);
    info.sourceInstitutionTable = this.toInstitutionTable(this.cloneHeaders(masterTable.headers), bean.sourceInstitutions);
    info.destinationInstitutionTable = this.toInstitutionTable(this.cloneHeaders(masterTable.headers), bean.destinationInstitutions);
    info.allInstitutionTable = masterTable;
    return info;
  }

  private cloneHeaders(headers: Header[]): Header[] {
    const clonedheaders: Header[] = [];
    for (const header of headers) {
      clonedheaders.push(header.clone());
    }
    return clonedheaders;
  }

  private toInstitutionTable(headers: Header[], beans: IInstitutionBean[]): LightTable {
    const rows = this.toInstitutionRows(beans);
    return new LightTable(headers, rows);
  }

  private toInstitutionRows(beans: IInstitutionBean[]): LightRow[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toInstitutionRow(bean));
  }

  private toInstitutionRow(bean: IInstitutionBean): LightRow {
    if (!bean) { return null; }
    const values: string[] = [];
    // TODO:V1の仕様の確認
    // どうやってカラムを一致させている？ハードコーディングで固定？
    values.push(bean.name);
    values.push(bean.kana);
    values.push(bean.faxNumber);
    values.push(bean.phoneNumber);
    values.push(bean.zipCode);
    values.push(bean.address);
    values.push(bean.drName);
    return new LightRow(values);
  }

  private toTable(bean: IInstitutionTableBean): LightTable {
    if (!bean) { return null; }
    const headers = this.toHeaders(bean.headers);
    const rows = this.toRows(bean.rows);
    return new LightTable(headers, rows);
  }

  private toHeaders(beans: IInstitutionHeaderBean[]): Header[] {
    if (!beans) { return []; }
    return beans.map(header => new Header(header.title, header.title, header.width));
  }

  private toRows(beans: IInstitutionRowBean[]): LightRow[] {
    if (!beans) { return []; }
    return beans.map(bean => this.toRow(bean));
  }

  private toRow(bean: IInstitutionRowBean): LightRow {
    if (!bean) { return null; }
    const values = !!bean.values ? bean.values : [];
    return new LightRow(values);
  }

  public toInstitutionBean(row: LightRow): IInstitutionBean {
    if (!row) { return null; }
    // TODO:V1の仕様の確認
    // どうやってカラムを一致させている？ハードコーディングで固定？
    return {
      name: row.values[0],
      kana: row.values[1],
      faxNumber: row.values[2],
      phoneNumber: row.values[3],
      zipCode: row.values[4],
      address: row.values[5],
      drName: row.values[6],
    };
  }
}
